import { useLocation } from 'react-router-dom';

const StorefrontOnly = ({ children }) => {
  const { pathname } = useLocation();
  const isAdminRoute = pathname === '/admin' || pathname.startsWith('/admin/');

  return isAdminRoute ? null : children;
};

export default StorefrontOnly;
